import styled from 'styled-components';
import { media } from 'style-utils';

const Header = styled.div`
  position: relative;
  margin: ${props => props.margin};
  min-height: ${props => props.lineHeight}px;

  ${media.mobileTablet`
    min-height: 0px;
  `}
`;

Header.defaultProps = {
 margin: '10px 0px 10px 0px',
  lineHeight: 78,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/layouts/Header.js